<template>
  <div class="row">
    <div class="col-12">
      <section class="register">
        <div class="container">
          <div class="register__group">
            <h1 class="register__title">Crie uma conta</h1>
            <p class="register__resume">
              Cadastre-se para agendar e acompanhar as suas consultas online com
              segurança.
            </p>

            <form class="register__form">
              <div
                class="form-group"
                :class="{ 'form-group--error': $v.user.name.$error }"
              >
                <input
                  id="inlineFormInputName"
                  v-model="$v.user.name.$model"
                  type="text"
                  class="form-control"
                  placeholder="Nome"
                />

                <div v-if="$v.user.name.$error">
                  <div v-if="!$v.user.name.required" class="error">
                    Campo obrigatório
                  </div>
                  <div v-if="!$v.user.name" class="error">Nome inválido</div>
                </div>
              </div>

              <div
                class="form-group"
                :class="{ 'form-group--error': $v.user.surname.$error }"
              >
                <input
                  id="inlineFormInputName"
                  v-model="$v.user.surname.$model"
                  type="text"
                  class="form-control"
                  placeholder="Sobrenome"
                />

                <div v-if="$v.user.name.$error">
                  <div v-if="!$v.user.surname.required" class="error">
                    Campo obrigatório
                  </div>
                  <div v-if="!$v.user.surname" class="error">Nome inválido</div>
                </div>
              </div>

              <div
                class="form-group"
                :class="{ 'form-group--error': $v.user.email.$error }"
              >
                <input
                  id="exampleInputEmail1"
                  v-model="$v.user.email.$model"
                  type="email"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="E-mail"
                  @input="delayTouch($v.user.email)"
                />

                <div v-if="$v.user.email.$error">
                  <div v-if="!$v.user.email.required" class="error">
                    Campo obrigatório
                  </div>
                  <div v-if="!$v.user.email.email" class="error">
                    Este email é inválido
                  </div>
                  <div v-if="!$v.user.email.isUnique" class="error">
                    Este email já está cadastrado
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                :class="{ 'form-group--error': $v.user.cpf.$error }"
              >
                <input
                  id="inlineFormInputCpf"
                  v-model="$v.user.cpf.$model"
                  v-mask="'###.###.###-##'"
                  type="tel"
                  class="form-control"
                  placeholder="CPF"
                  @input="delayTouch($v.user.cpf)"
                />

                <div v-if="$v.user.cpf.$error">
                  <div v-if="!$v.user.cpf.required" class="error">
                    Campo obrigatório
                  </div>
                  <div v-if="!$v.user.cpf.cpf" class="error">
                    Este CPF é inválido
                  </div>
                  <div v-if="!$v.user.cpf.isUnique" class="error">
                    Este CPF já está cadastrado
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                :class="{ 'form-group--error': $v.user.birthday.$error }"
              >
                <input
                  id="inlineFormInputBirthday"
                  v-model="$v.user.birthday.$model"
                  v-mask="'##/##/####'"
                  type="tel"
                  class="form-control"
                  placeholder="Data de nascimento"
                />

                <div v-if="$v.user.birthday.$error">
                  <div v-if="!$v.user.birthday.required" class="error">
                    Campo obrigatório
                  </div>
                  <div
                    v-if="!$v.user.birthday.minAge || !$v.user.birthday.maxAge"
                    class="error"
                  >
                    Data inválida
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                :class="{ 'form-group--error': $v.user.phone_number.$error }"
              >
                <input
                  id="inlineFormInputPhone"
                  v-model="$v.user.phone_number.$model"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  type="tel"
                  class="form-control"
                  placeholder="Telefone"
                />

                <div v-if="$v.user.phone_number.$error">
                  <div v-if="!$v.user.phone_number.required" class="error">
                    Campo obrigatório
                  </div>
                  <div v-if="!$v.user.phone_number" class="error">
                    Número inválido
                  </div>
                  <div v-if="!$v.user.phone_number.isUnique" class="error">
                    Este telefone já está cadastrado
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                :class="{ 'form-group--error': $v.user.password.$error }"
              >
                <input
                  id="exampleInputPassword1"
                  v-model="$v.user.password.$model"
                  type="password"
                  class="form-control"
                  placeholder="Nova senha"
                />

                <div v-if="$v.user.password.$error">
                  <div v-if="!$v.user.password.required" class="error">
                    Campo obrigatório
                  </div>
                  <div v-if="!$v.user.password.minLength" class="error">
                    Deve conter no mínimo, 8 caracteres
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                :class="{
                  'form-group--error': $v.user.password_confirmation.$error
                }"
              >
                <input
                  id="exampleInputPassword2"
                  v-model="$v.user.password_confirmation.$model"
                  type="password"
                  class="form-control"
                  placeholder="Repita a senha"
                />

                <div v-if="$v.user.password_confirmation.$error">
                  <div
                    v-if="!$v.user.password_confirmation.required"
                    class="error"
                  >
                    Campo obrigatório
                  </div>
                  <div
                    v-if="!$v.user.password_confirmation.minLength"
                    class="error"
                  >
                    Deve conter no mínimo, 8 caracteres
                  </div>
                  <div
                    v-if="!$v.user.password_confirmation.confirmPassword"
                    class="error"
                  >
                    Senhas não correspondem
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    id="customRadioInline1"
                    v-model="userType"
                    type="radio"
                    value="doctor"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" for="customRadioInline1">
                    Profissional de saúde
                  </label>
                </div>

                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    id="customRadioInline2"
                    v-model="userType"
                    type="radio"
                    value="patient"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" for="customRadioInline2">
                    Paciente
                  </label>
                </div>
              </div>

              <div v-if="userType == 'doctor'">
                <div
                  class="form-group"
                  :class="{
                    'form-group--error':
                      $v.doctor_property_attributes.council_id.$error
                  }"
                >
                  <label style="color: gray">Conselho:</label>
                  <select
                    v-model="$v.doctor_property_attributes.council_id.$model"
                    class="custom-select"
                  >
                    <option
                      v-for="council in this.$store.state.council.councils"
                      :key="council.id"
                      :value="council.id"
                    >
                      {{ council.name }}
                    </option>
                  </select>

                  <div v-if="$v.doctor_property_attributes.council_id.$error">
                    <div
                      v-if="!$v.doctor_property_attributes.council_id.required"
                      class="error"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>

                <div
                  class="form-group"
                  :class="{
                    'form-group--error':
                      $v.doctor_property_attributes.council_uf.$error
                  }"
                >
                  <label style="color: gray">Estado:</label>
                  <select
                    v-model="$v.doctor_property_attributes.council_uf.$model"
                    class="custom-select"
                  >
                    <option v-for="uf in ufs" :key="uf.id">
                      {{ uf }}
                    </option>
                  </select>

                  <div v-if="$v.doctor_property_attributes.council_uf.$error">
                    <div
                      v-if="!$v.doctor_property_attributes.council_uf.required"
                      class="error"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>

                <div
                  class="form-group"
                  :class="{
                    'form-group--error':
                      $v.doctor_property_attributes.medical_specialty_id.$error
                  }"
                >
                  <label style="color: gray">Especialidade:</label>
                  <select
                    v-model="
                      $v.doctor_property_attributes.medical_specialty_id.$model
                    "
                    class="custom-select"
                  >
                    <option
                      v-for="speciality in $store.state.speciality.specialities"
                      :key="speciality.id"
                      :value="speciality.id"
                    >
                      {{ speciality.name }}
                    </option>
                  </select>

                  <div
                    v-if="
                      $v.doctor_property_attributes.medical_specialty_id.$error
                    "
                  >
                    <div
                      v-if="
                        !$v.doctor_property_attributes.medical_specialty_id
                          .required
                      "
                      class="error"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>

                <div
                  class="form-group"
                  :class="{
                    'form-group--error':
                      $v.doctor_property_attributes.council_number.$error
                  }"
                >
                  <input
                    v-model="
                      $v.doctor_property_attributes.council_number.$model
                    "
                    class="form-control"
                    placeholder="Numero do registro"
                  />

                  <div
                    v-if="$v.doctor_property_attributes.council_number.$error"
                  >
                    <div
                      v-if="
                        !$v.doctor_property_attributes.council_number.required
                      "
                      class="error"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>

                <div
                  class="form-group"
                  :class="{
                    'form-group--error':
                      $v.doctor_property_attributes.short_bio.$error
                  }"
                >
                  <textarea
                    id="exampleFormControlTextarea1"
                    v-model="$v.doctor_property_attributes.short_bio.$model"
                    class="form-control"
                    type="text"
                    rows="4"
                    placeholder="Breve descricao"
                  />

                  <div v-if="$v.doctor_property_attributes.short_bio.$error">
                    <div
                      v-if="!$v.doctor_property_attributes.short_bio.required"
                      class="error"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>
              </div>

              <div class="custom-control custom-checkbox">
                <input
                  id="customCheck1"
                  v-model="terms"
                  type="checkbox"
                  class="custom-control-input"
                  name="checkbox-1"
                  :value="true"
                  :unchecked-value="false"
                />

                <label class="custom-control-label" for="customCheck1">
                  Ao clicar em criar uma conta, você está concordando com os
                  <a>Termos de Uso</a>
                  e a
                  <a>Política de Privacidade</a>
                  .
                </label>
              </div>

              <button
                :disabled="!canRegister"
                class="button3"
                :class="{ disable: !canRegister }"
                @click.prevent="sendRegister()"
              >
                Criar uma conta
              </button>
            </form>
          </div>
        </div>
      </section>

      <section class="option-account">
        <div class="container option-account__wrapper">
          <p class="create-account__item">
            Já possui uma conta?
            <a href="/login">Faça Login</a>
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {
  authMethods,
  userMethods,
  doctorComputed,
  specialityMethods,
  specialityGetter,
  councilMethods,
  councilGetter
} from "./../state/helpers";
import {
  required,
  minLength,
  email,
  sameAs,
  helpers
} from "vuelidate/lib/validators";
import { cpf } from "../utils/validations/cpf";
import { moreThan18y, differenceInYearsFromNow } from "./../utils/dates/format";

const touchMap = new WeakMap();

export default {
  name: "Register",
  data() {
    return {
      user: {
        name: "",
        surname: "",
        email: "",
        cpf: "",
        birthday: "",
        phone_number: "",
        password: "",
        password_confirmation: ""
      },
      doctor_property_attributes: {
        council_id: "",
        medical_specialty_id: "",
        short_bio: "",
        council_number: "",
        council_uf: ""
      },
      userType: "patient",
      terms: false,
      colorButton: true,
      ufs: [
        "AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO"
      ],
      redirectFrom: ""
    };
  },

  validations() {
    return {
      user: {
        name: { required },
        surname: { required },
        email: {
          required,
          email,
          async isUnique(value) {
            if (value.includes("@")) {
              await this.emailVerification({ email: value }).then(response => {
                return response.data.status;
              });
            }
            return true;
          }
        },
        cpf: {
          required,
          cpf,
          async isUnique(value) {
            if (value.length == 14) {
              await this.cpfVerification({
                cpf: value.replace("-", "").replace(".", "").replace(".", "")
              }).then(response => {
                return response.data.status;
              });
            }
            return true;
          }
        },
        birthday: {
          required,
          minAge: function (value) {
            if (value.length == 10) return moreThan18y(value) > 18;

            return false;
          },
          maxAge: function (value) {
            if (value.length == 10)
              return differenceInYearsFromNow(value) < 150;

            return false;
          }
        },
        phone_number: {
          required,
          async isUnique(value) {
            if (value.length >= 14) {
              await this.phoneNumberVerification({
                phone_number: value.replace(/[^0-9\.]+/g, "")
              }).then(response => {
                return response.data.status;
              });
            }
            return true;
          }
        },
        password: {
          required,
          minLength: minLength(8)
        },
        password_confirmation: {
          required,
          minLength: minLength(8),
          confirmPassword: sameAs("password")
        }
      },
      doctor_property_attributes: {
        council_id: { required },
        medical_specialty_id: { required },
        short_bio: { required },
        council_number: { required },
        council_uf: { required }
      }
    };
  },
  mounted() {
    this.redirectFrom = this.$route.query.redirectFrom;
    this.fetchAllSpecialities();
    this.fetchAllCouncils();
  },
  methods: {
    ...userMethods,
    ...councilMethods,
    ...specialityMethods,
    ...authMethods,
    sendRegister() {
      this.$v.user.$touch();
      this.$v.doctor_property_attributes.$touch();
      let user = {
        redirectFrom: this.redirectFrom,
        ...this.user,
        account_type: this.userType,
        name: this.user.name + " " + this.user.surname,
        cpf: this.user.cpf.replace("-", "").replace(".", "").replace(".", ""),
        phone_number: this.user.phone_number
          .replace("(", "")
          .replace(")", "")
          .replace("-", "")
      };

      if (this.userType == "doctor") {
        user.doctor_property_attributes = {
          ...this.doctor_property_attributes
        };
      }

      if (
        !this.$v.user.$invalid ||
        !this.$v.doctor_property_attributes.$invalid
      ) {
        this.register(user).then(path => {
          if (this.userType == "doctor")
            this.initMemed(
              this.$store.state.user.currentUser.doctor_property.memed_token
            );

          this.$router.push({ path });
        });
      }
    },
    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1000));
    },
    initMemed(token) {
      let script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("id", "memed-script");
      script.setAttribute("data-color", "#1abc9c");
      script.setAttribute("data-token", token);
      script.setAttribute("data-container", "memed-container");
      script.src =
        "https://sandbox.memed.com.br/modulos/plataforma.sinapse-prescricao/build/sinapse-prescricao.min.js";
      document.body.appendChild(script);
    }
  },
  computed: {
    ...specialityGetter,
    ...councilGetter,
    ...doctorComputed,
    canRegister() {
      return this.isFormValid && this.terms;
    },
    patientFormIsValid() {
      return !this.$v.user.$invalid && this.userType == "patient";
    },
    doctorFormIsValid() {
      return (
        this.userType == "doctor" &&
        !this.$v.user.$invalid &&
        !this.$v.doctor_property_attributes.$invalid
      );
    },
    isFormValid() {
      return this.patientFormIsValid || this.doctorFormIsValid;
    }
  }
};
</script>

<style>
.error {
  color: red;
}

.disable {
  background-color: rgba(128, 128, 128, 0.542);
  border: 1px solid;
}

.disable:hover {
  background-color: rgba(128, 128, 128, 0.542);
}
</style>
